import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { EnumConverterService } from '../../../services/EnumConverterService';
import { BaseOption } from '../../../model/BaseOption';
import { OptionsEnum } from 'src/app/model/enums/OptionsEnum';
import { WaitingPeriod } from 'src/app/model/enums/WaitingPeriodEnum';
import { SessionGgService } from '../../../services/session-gg.service';
import { CalculationGgService } from '../../../services/calculation-gg.service';
import { SessionService } from '../../../session-service.service';
import { ProductTypeEnum } from '../../../model/enums/ProductTypeEnum';
import { NOTIFICATION_TYPE, NotificationEvent, NotificationService } from '../../../services/NotificationService';
import { Subscription } from 'rxjs';

const INDEXATION_PERCENTAGE = '2';

@Component({
  selector: 'app-product-info-page-gg',
  templateUrl: './product-info-page.component.html',
  styleUrls: ['./product-info-page.component.css'],
})
export class ProductInfoPageComponent implements OnInit, OnDestroy {
  form;
  waitingPeriodList: BaseOption[] = [];
  yesNoList: BaseOption[] = [];
  productType = ProductTypeEnum.GG;
  notificationEvent: NotificationEvent;
  notificationSubscription: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private enumConverterService: EnumConverterService,
    private sessionGgService: SessionGgService,
    private calculationGgService: CalculationGgService,
    private sessionService: SessionService,
    private notificationService: NotificationService,
  ) {
    this.waitingPeriodList = this.enumConverterService.toBaseList('WaitingPeriodEnum', WaitingPeriod);
    this.yesNoList = this.enumConverterService.toBaseList('OptionsEnum', OptionsEnum);
    this.initDataFromSession();
  }

  ngOnInit(): void {
    this.listenToNotifications();
  }

  ngOnDestroy(): void {
    this.notificationSubscription.unsubscribe();
  }

  listenToNotifications(): void {
    this.notificationSubscription = this.notificationService.register().subscribe((event) => {
      this.notificationEvent = event;
    });
  }

  doCalculation(): void {
    this.notificationEvent = {
      type: NOTIFICATION_TYPE.HIDDEN,
    };
    const requestDTO = this.sessionService.getCallculationRequest();
    requestDTO.insureds[0].covers[0].variables.mentalIllnessIncluded.value = this.form.controls.mentalIllness.value === 'Yes' ? 'true' : 'false';
    requestDTO.insureds[0].covers[0].variables.waitingPeriod.value = this.form.controls.waitingPeriod.value;
    requestDTO.variables.indexationUsage.value = this.form.controls.indexationUsage.value === OptionsEnum.Yes ? 'CLAIM_AND_POLICY' : 'NO_INDEXATION';
    requestDTO.variables.indexationPercentage.value = this.form.controls.indexationUsage.value === OptionsEnum.Yes ? INDEXATION_PERCENTAGE : '0';
    this.sessionService.setCalculationRequest(requestDTO);
    this.calculationGgService.requestCalculateGG();
    const calculationPageValues = this.sessionGgService.getCalculationPageValues();
    this.sessionGgService.setCalculationPageValues({
      ...calculationPageValues,
      ...this.form.value,
    });
  }

  get isValidCalculation(): boolean {
    return this.notificationEvent ? this.notificationEvent.type === NOTIFICATION_TYPE.HIDDEN : true;
  }

  submitApplication(): void {}

  initDataFromSession(): void {
    const {
      waitingPeriod,
      mentalIllness,
      indexationUsage,
    } = this.sessionGgService.getCalculationPageValues();

    this.form = this.formBuilder.group({
      waitingPeriod: [waitingPeriod],
      mentalIllness: [mentalIllness],
      indexationUsage: [indexationUsage],
    });

    this.form.valueChanges.subscribe(() => {
      this.doCalculation();
    });
  }
}
